import React from 'react'
import styled from 'styled-components'
import { Switch, Route } from 'react-router-dom'

import LoginPage from '../pages/LoginPage'
import WelcomePage from '../pages/WelcomePage'
import config from '../config'
import routes from '../routes'
import { SIZES } from '../styles/theme'

const Page = styled.div`
  background: url(${config.assets.entrance.landscape}) no-repeat center center fixed;
  background-size: cover;
  height: 100vh;
  width: 100vw;
  overflow: hidden;

  ${SIZES.mobile} {
    background: url(${config.assets.entrance.portrait}) no-repeat center top fixed;
    background-size: cover;
  }
`

export default function EntrancePages({ children }) {
  return (
    <Page>
      <Switch>
        <Route exact path={routes.root} component={WelcomePage} />
        <Route path={routes.login} component={LoginPage} />
      </Switch>
    </Page>
  )
}
